<template>
  <b-modal id="modal-importar-lista" dialog-class="modal-conta" hide-footer :no-enforce-focus="true" centered>
    <template slot="modal-header">
      <h5 class="modal-title">Importar lista de cupons</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-importar-lista')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <div class="row">
      <div class="col-12 col-md">
        <a :href="baseFile" download>Download arquivo template</a>
      </div>
    </div>

    <div class="form-group mt-4 mb-2">
      <label for="importar-lista" class="sr-only">Importar lista de cupons</label>
      <input type="file" class="form-control-file" id="importar-lista" ref="file" v-on:change="handleFileUpload">
    </div>

    <h6><i class="fas fa-users"></i> Público alvo do cupom</h6>
    <div v-if="publicoAlvoCupons && cupom.publicoAlvoCupons" class="row">
      <div class="col-12">
        <p class="tit-checks">Planos<i class="fas fa-info-circle ml-2" v-b-popover.hover.top="'O cupom será aplicado para o(s) plano(s)'"></i></p>
      </div>
      <div v-for="plano in publicoAlvoCupons.planos_macro" class="col-12 col-md-4">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input"
          :id="'publicoAlvoCuponsPlanos'+plano.id" :value="true"
          v-model="cupom.publicoAlvoCupons.planosMacro[plano.id].checked"
          :ref="'publicoAlvoCuponsPlanos'+plano.id">
          <label class="custom-control-label" :for="'publicoAlvoCuponsPlanos'+plano.id" v-text="plano.nome"></label>
        </div>
      </div>
    </div>
    <div v-if="publicoAlvoCupons && cupom.publicoAlvoCupons" class="row">
      <div class="col-12">
        <p class="tit-checks mt-3">Periodicidade<i class="fas fa-info-circle ml-2" v-b-popover.hover.top="'O cupom será aplicado para a(s) periodicidade(s)'"></i></p>
      </div>
      <div v-for="periodo in publicoAlvoCupons.periodicidade" class="col-12 col-md-4">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input"
          :id="'publicoAlvoCuponsPeriodicidade'+periodo.id" :value="true"
          v-model="cupom.publicoAlvoCupons.periodicidade[periodo.id].checked"
          :ref="'publicoAlvoCuponsPeriodicidade'+periodo.id">
          <label class="custom-control-label" :for="'publicoAlvoCuponsPeriodicidade'+periodo.id" v-text="periodo.nome"></label>
        </div>
      </div>
    </div>

    <div v-if="publicoAlvoCupons && cupom.publicoAlvoCupons" class="row">
      <div class="col-12">
        <p class="tit-checks mt-3">Com adicionais<i class="fas fa-info-circle ml-2" v-b-popover.hover.top="'Cupom será aplicado somente se o usuário tiver esses adicionais'"></i></p>
      </div>
      <div v-for="plano_macro_required in publicoAlvoCupons.planos_macro_required" class="col-12 col-md-4">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input"
          :id="'publicoAlvoCuponsPlanoMacroRequired'+plano_macro_required.id" :value="true"
          v-model="cupom.publicoAlvoCupons.planosMacroRequired[plano_macro_required.id].checked">
          <label class="custom-control-label" :for="'publicoAlvoCuponsPlanoMacroRequired'+plano_macro_required.id" v-text="plano_macro_required.nome"></label>
        </div>
      </div>
    </div>

    <div class="text-center">
      <div class="d-flex align-items-center justify-content-center mt-5 mb-4">
        <a href="javascript:void(0)" class="btn btn-primary mr-3" @click="importarCupons">Importar</a>
        <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-importar-lista')">Cancelar</a>
      </div>
    </div>

  </b-modal>
</template>

<script>
import UrlUtils from '@/core/util/url-utils'
import Swal from 'sweetalert2'
import CupomAPI from '@/api/cupom-api'

export default {
  name: 'ModalImportacaoCupons',
  props: {
    publicoAlvoCupons: Object
  },
  data () {
    return {
      cupom: {
        publicoAlvoCupons: null
      },
      file: null,
      baseFile: UrlUtils.obterUrlS3('modelo_importacao/import_cupons_template.csv')
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.file = null

      let planosMacro = []
      let periodicidade = []
      let planosMacroRequired = []

      this.publicoAlvoCupons.planos_macro.forEach(item => {
        if (item.id === 7) {
          planosMacro[item.id] = { 'id': item.id, 'checked': false, 'nome': item.nome }
        } else {
          planosMacro[item.id] = { 'id': item.id, 'checked': true, 'nome': item.nome }
        }
      })
      this.publicoAlvoCupons.periodicidade.forEach(item => {
        periodicidade[item.id] = { 'id': item.id, 'checked': true, 'nome': item.nome }
      })
      this.publicoAlvoCupons.planos_macro_required.forEach(item => {
        planosMacroRequired[item.id] = { 'id': item.id, 'checked': false, 'nome': item.nome }
      })
      this.cupom.publicoAlvoCupons = { planosMacro, planosMacroRequired, periodicidade }
    })
  },

  methods: {

    show: function () {
      this.$bvModal.show('modal-importar-lista')
    },

    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
    },
    importarCupons: function () {
      if (!this.file) {
        Swal.fire({
          icon: 'error',
          text: 'Obrigatório informar o arquivo para importação.'
        })
        return
      }

      let reg = /(.*?)\.(csv)$/
      if (!this.file.name.match(reg)) {
        Swal.fire({
          icon: 'error',
          text: 'O arquivo enviado deve ser um CSV.'
        })
        return
      }

      CupomAPI.importarCupons(this.file, this.cupom)

      Swal.fire({
        icon: 'success',
        html: 'Arquivo para importação de cupons enviado com sucesso.<br>' +
        '<a href="/cupom/importacao/resultado" target="_blank">Clique aqui para visualizar o relatorio</a>'
      }).then(() => {
        this.$bvModal.hide('modal-importar-lista')
      })
    }

  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
